import { render } from "./RiverDetail.vue?vue&type=template&id=8dc200c4&scoped=true"
import script from "./RiverDetail.vue?vue&type=script&lang=js"
export * from "./RiverDetail.vue?vue&type=script&lang=js"

import "./RiverDetail.vue?vue&type=style&index=0&id=8dc200c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc200c4"]])

export default __exports__